const {
  compose,
  prop,
  reverse,
  sortBy,
  take,
  toLower,
} = require('ramda')

const self = {}

self.first = take

self.sortByName = sortBy(compose(toLower, prop('name')))

self.sortByCreatedDesc = function (list) {
  return reverse(sortBy(prop('createdAt'), list))
}

module.exports = self
